import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_2 = {
  key: 1,
  class: "absolute bg-primary-600 bottom-[-25px] w-full h-1 rounded-t-lg block transition"
}
const _hoisted_3 = {
  key: 1,
  class: "flex lg:flex-col flex-row gap-2"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "flex gap-2"
}
const _hoisted_6 = ["onClick"]

import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";
import { useRouter, useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabComponent',
  props: {
	tabs: {
		type: Object,
		default: () => ({}),
	},
	buttonItems: {
		type: Boolean,
		default: false,
	},
	href: {
		type: String,
		default: null,
	},
	typeTwo: {
		type: Boolean,
		default: false,
	},
	typeThree: {
		type: Boolean,
		default: false,
	},
	returnObject: {
		type: Boolean,
		default: false,
	},
	activeTab: {
		type: String,
		default: null,
	},
},
  emits: ["update:tab"],
  setup(__props, { emit: __emit }) {

// import { ref } from 'vue';
const emit = __emit;
const props = __props;

const router = useRouter();
const route = useRoute();

const isSelectedTab = (value:any) => {
	return props.activeTab == value;
};

const visitPage = (data: any) => {
	emit("update:tab", props.returnObject ? data : data.tab); // callback emit for axios fetching
	if (data?.href) {
		router.push(data.href); // push on a web browser
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.typeTwo && !__props.typeThree)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(TabGroup), null, {
            default: _withCtx(() => [
              _createVNode(_unref(TabList), { class: "flex space-x-4" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tab.name
                    }, [
                      (tab.allowed)
                        ? (_openBlock(), _createBlock(_unref(Tab), {
                            key: 0,
                            as: "template",
                            onClick: ($event: any) => (visitPage(tab))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: _normalizeClass([
								_unref(route).fullPath == tab.href ? 'text-primary-600' : 'text-gray-600 hover:text-primary-600',
								'text-sm focus:outline-none w-max relative cursor-pointer relative ring-0 outline-none transition',
							])
                              }, [
                                _createElementVNode("span", null, _toDisplayString(tab.name), 1),
                                (tab.count)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass([
									_unref(route).fullPath == tab.href
										? 'bg-primary-300 text-primary-600'
										: 'bg-[#F3F4F6] text-gray-600',
									'py-0.5 px-2 ml-2 rounded-[10px] inline-block text-xs',
								])
                                    }, _toDisplayString(tab.count), 3))
                                  : _createCommentVNode("", true),
                                (_unref(route).fullPath == tab.href)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (__props.typeTwo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              type: "button",
              key: tab.name,
              onClick: ($event: any) => (visitPage(tab)),
              class: _normalizeClass(["px-3 py-2 text-xs font-bold focus:outline-none w-max", _unref(route).fullPath == tab.href ? 'bg-primary-300 text-primary-600' : 'bg-transparent text-neutral-600'])
            }, _toDisplayString(tab.name), 11, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (__props.typeThree)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              type: "button",
              key: tab.name,
              onClick: ($event: any) => (visitPage(tab)),
              class: _normalizeClass(["md:px-1 px-1.5 md:py-0.5 py-1.5 md:text-xs text-sm font-bold focus:outline-none w-max md:rounded-lg rounded-full relative after:content-[''] after:border-r after:border-neutral-100 after:top-0 after:-right-1 after:absolute after:w-[1px] after:h-full", isSelectedTab(tab.tab) ? 'bg-primary-600 text-white' : 'bg-transparent text-neutral-600'])
            }, [
              _createTextVNode(_toDisplayString(tab.name) + " ", 1),
              (tab.count)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass([
					isSelectedTab(tab.tab)
						? 'md:bg-primary-300 bg-white text-primary-600'
						: 'bg-primary-600 bg-opacity-20 text-primary-600',
					'md:py-0 py-0.5 md:px-1 px-2 md:ml-1 ml-2 rounded-full font-bold inline-block text-xs',
				])
                  }, _toDisplayString(tab.count), 3))
                : _createCommentVNode("", true)
            ], 10, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})